import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { TMediaItemPayloadType, TMediaItemPayload } from '../MediaMessagePopup.types';
import { IItemMediaPresenter, useItemMediaPresenter } from './ItemMedia.presenter';
import styles from './ItemMedia.styles.m.css';
import { MediaMessageFile } from './MediaMessageFile/MediaMessageFile';
import { MediaMessageImage } from './MediaMessageImage/MediaMessageImage';
import { MediaMessageVideo } from './MediaMessageVideo/MediaMessageVideo';

const MAP_COMPONENTS: Record<
  TMediaItemPayloadType,
  FC<{ presenter: IItemMediaPresenter; onRemove?(): void }>
> = {
  [PayloadType.Image]: MediaMessageImage,
  [PayloadType.File]: MediaMessageFile,
  [PayloadType.AudioMessage]: MediaMessageFile,
  [PayloadType.Video]: MediaMessageVideo,
};

interface IItemMediaProps {
  className?: string;
  payload: TMediaItemPayload;
  onRemove?(payload: TMediaItemPayload): void;
}

export const ItemMedia: FC<IItemMediaProps> = observer(({ className, payload, onRemove }) => {
  const presenter = useItemMediaPresenter({ payload, onRemove });
  if (!presenter.payload || !presenter.payloadType) {
    return null;
  }
  const Component = MAP_COMPONENTS[presenter.payloadType];
  return (
    <div className={classNames(styles.container, className)}>
      <Component
        presenter={presenter}
        onRemove={presenter.onRemove}
      />
    </div>
  );
});
